import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

/*
 * To use this component:
 * Add <automata-zoom-control (zoomLevel)="zoomLevel = $event"></automata-zoom-control> in your html file.
 * A zoomLevel class variable will need to be added to your component.
 * Add @use '<path>/zoom-control/zoom-control-styles' as *; to your scss file.
 * [ngClass]="'zoomLevel-' + zoomLevel" to the html element you want to be scaled.
 * */

@Component({
  selector: 'automata-zoom-control',
  templateUrl: './zoom-control.component.html',
  styleUrls: ['./zoom-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, GalaxyButtonGroupModule, MatButton, MatIcon, GalaxyTooltipModule, TranslateModule],
})
export class ZoomControlComponent {
  @Input() maxZoom = 20;
  @Input() minZoom = 1;
  @Input() newView = false;
  @Output() zoomLevel = new EventEmitter<number>();
  @Output() centerToTrigger = new EventEmitter<void>();

  TOOLTIP_TOP_RIGHT = [{ ...PopoverPositions.TopRight }];

  _zoomLevel = 10;
  zoomLevelDisplay = '100%';

  zoomIn(): void {
    if (this._zoomLevel < 20) {
      this._zoomLevel++;
    }
    this.updateZoomLevelDisplay();
  }

  zoomOut(): void {
    if (this._zoomLevel > 1) {
      this._zoomLevel--;
    }
    this.updateZoomLevelDisplay();
  }

  resetZoom(): void {
    this._zoomLevel = 10;
    this.updateZoomLevelDisplay();
  }

  updateZoomLevelDisplay(): void {
    if (this._zoomLevel < 11) {
      this.zoomLevelDisplay = 10 * this._zoomLevel + '%';
    } else {
      this.zoomLevelDisplay = 100 + 20 * (this._zoomLevel - 10) + '%';
    }
    this.zoomLevel.emit(this._zoomLevel);
  }
}
